<template lang="pug">
  .block.block_wide
    .block__body.block__item
      .block__body-item
        h2 Основная информация
      .loader.m-0(v-if="!(isLoaded && isFilled)")
      .block__body-item(v-else)
        form.form(
          :class="{'form_show-err': showErrors}"
          @submit.prevent="submit"
          novalidate
        )
          .form__item(
            :class="{'has-error': $v.fields.title.$error, 'has-success': showErrors && !$v.fields.title.$error && !nameIsChecking && nameIsChecked, 'has-progress': nameIsChecking, 'show-errors': nameIsExist && fields.title }"
          )
            .field.field_row
              .field__label
                label.label Название
              .field__input
                .input
                  input.input__el(
                    v-model.trim="fields.title"
                    type="text"
                    name="title"
                    placeholder="Название клуба"
                    :disabled="nameIsChecking"
                    autocomplete="off"
                    @input="() => { nameIsChecked = nameIsExist = false }"
                    @blur="nameIsChecked = true"
                    @change="() => { $v.fields.title.$touch(); checkName() }"
                  )
                  .input__icons
                    .input__icon.input__icon-err
                      icon(icon-name='exclamation-circle-s')
                    .input__icon.input__icon-valid
                      icon(icon-name='check-bold')
                    .input__icon.input__icon-progress
                      .icon.icon-loader
                  .input__border
                .field__msg
                  .field-msg(
                    v-if="!$v.fields.title.required"
                    v-html="messages.title.required"
                  )
                  .field-msg(
                    v-else-if="!$v.fields.title.allowedChars"
                    v-html="messages.title.allowedChars"
                  )
                  .field-msg(
                    v-else-if="!$v.fields.title.maxLength"
                    v-html="messages.title.maxLength.replace('{0}', $v.fields.title.$params.maxLength.max)"
                  )
                  .field-msg(
                    v-else-if="!$v.fields.title.isNotExist"
                    v-html="messages.title.isNotExist"
                  )
          .form__item(
            :class="{'has-error': $v.fields.logo.$error || logoFormatError || logoSizeError, 'show-errors': logoFormatError || logoSizeError, 'has-success': showErrors && !$v.fields.logo.$error}"
          )
            .form__field
              .field.field_row
                .field__label
                  label.label Логотип
                .field__input
                  InputFile(
                    ref="file"
                    name="logo"
                    :maxSize="2"
                    :text="fields.logoName"
                    @change="onLogoChange"
                  )
                  .field__msg
                    .field-msg(
                      v-if="logoFormatError"
                    ) Неверный формат файла
                    .field-msg(
                      v-else-if="logoSizeError"
                    ) Размер файла не&nbsp;должен превышать 2&nbsp;МБ
                    .field-msg(
                      v-else-if="!$v.fields.logo.required"
                      v-html="messages.logo.required"
                    )
            img.d-none(ref="logoPreview" :src="fields.logo" alt="")
            .form__field
              Cropper(
                ref="cropper"
                :maxSize="2"
                :hideCropper="hideCropper"
                @change="onCropperChange"
              )
                template(slot="preview")
                  ClubCard(
                    :isEmpty="true"
                    :data="{logoImage: fields.logo}"
                  )
          .form__item(
            :class="{'has-error': !$v.fields.location.required || (!$v.fields.location.isFilled && !locationDropdownIsOpened), 'has-success': showErrors && fields.location && !$v.fields.location.$error}"
          )
            .field.field_row
              .field__label
                label.label Место
              .field__input
                .form__field
                  .input
                    input.input__el(
                      v-model.trim="fields.location"
                      type="text"
                      name="location"
                      placeholder="Например: Москва, Селтинская, 25а"
                      @input="loadAddresses"
                      @change="$v.fields.location.$touch"
                      ref="locationInput"
                      autocomplete="off"
                    )
                    .input__icons
                      .input__icon.input__icon-err
                        icon(icon-name='exclamation-circle-s')
                      .input__icon.input__icon-valid
                        icon(icon-name='check-bold')
                    .input__border
                  .field__msg
                    .field-msg(
                      v-if="!$v.fields.location.required"
                      v-html="messages.location.required"
                    )
                    .field-msg(
                      v-else-if="!$v.fields.location.isFilled"
                      v-html="messages.location.isFilled"
                    )
                  Dropdown.location-dropdown(
                    trigger="locationInput"
                    ref="locationDropdown"
                    :hideOverlay="true"
                    listeners="focus"
                  )
                    template(slot="items")
                      .dropdown__hints(v-show="!addresses.length")
                        .text-xs.color-muted(v-if="locationIsLoading && fields.location") Загрузка...
                        .text-xs.color-muted(v-else-if="locationNotFound") Ничего не найдено
                        .text-xs.color-muted(v-else) Начните ввод для поиска...
                      .dropdown__item(v-for="address in addresses")
                        a.dropdown__link(
                          href="#"
                          @click.prevent="saveLocation(address)"
                        )
                          span.dropdown__text(v-html="address.valueMarked")
                .form__field
                  label.checkbox
                    span.checkbox__content
                      input.checkbox__input(
                        v-model="fields.isOnline"
                        type="checkbox"
                        name="is_online"
                        @change="$v.$touch"
                      )
                      span.checkbox__marker
                        icon(icon-name='check-bold')
                      span.checkbox__text Онлайн клуб (весь мир)
          .form__item(
            :class="{'has-error': $v.fields.disciplines.$error}"
          )
            .field.field_row
              .field__label
                label.label Спортивная специализация
              .field__input
                .grid
                  .grid__col.grid__col_sm-12
                    template(v-for="discipline in disciplinesColumns[0]")
                      label.checkbox
                        span.checkbox__content
                          input.checkbox__input(
                            v-model="fields.disciplines"
                            type="checkbox"
                            name="disciplines"
                            :value="discipline.id"
                            @change="$v.fields.disciplines.$touch"
                          )
                          span.checkbox__marker
                            icon(icon-name='check-bold')
                          span.checkbox__text(v-html="discipline.value")
                      br
                  .grid__col.grid__col_sm-12
                    template(v-for="discipline in disciplinesColumns[1]")
                      label.checkbox
                        span.checkbox__content
                          input.checkbox__input(
                            v-model="fields.disciplines"
                            type="checkbox"
                            name="disciplines"
                            :value="discipline.id"
                            @change="$v.fields.disciplines.$touch"
                          )
                          span.checkbox__marker
                            icon(icon-name='check-bold')
                          span.checkbox__text(v-html="discipline.value")
                      br
                .field__msg
                  .field-msg(
                    v-if="!$v.fields.disciplines.required"
                    v-html="messages.disciplines.required"
                  )
          .form__item(
            :class="{'has-error': $v.fields.description.$error}"
          )
            .field
              .field__label
                label.label.text-md О&nbsp;клубе
              .field__subtitle.text-sm Опишите концепцию вашего клуба, особенности и&nbsp;условиях вступления. Расскажите, для&nbsp;кого создан клуб, и&nbsp;почему в&nbsp;него стоит вступить.
              .field__input
                TextEditor(
                  :content="fields.description"
                  @update="$val => { fields.description = $val; $v.fields.description.$touch() }"
                )
              .field__msg
                .field-msg(
                  v-if="$v.fields.description.$error"
                  v-html="messages.description.required"
                )
          .form__item
            .divider
          .form__item
            button.button.button_primary.button_wide.button_lg(
              :class="{'disabled': (showErrors && $v.$anyError) || !hasChanges, 'button_loading': isSending, 'button_done': isSent}"
              :disabled="(showErrors && $v.$anyError) || !hasChanges || isSending || nameIsChecking"
              type="submit"
            )
              span.button__text Сохранить
              span.button__icon.button__loading
                icon(icon-name='loading')
              span.button__icon.button__done
                icon(icon-name='check-bold')
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import TextEditor from '@/components/TextEditor'
import Cropper from '@/components/Cropper'
import InputFile from '@/components/InputFile'
import ClubCard from '@/components/ClubCard'
import { getAddresses, markQueryInStr } from '@/assets/js/dadata.js'
import { clone, isEqual } from 'lodash'

export default {
  name: 'ManageSettings',
  components: {
    TextEditor,
    Cropper,
    InputFile,
    ClubCard
  },
  data () {
    return {
      hideCropper: true,
      fields: {
        title: null,
        logo: null,
        logoName: null,
        location: null,
        isOnline: null,
        disciplines: [],
        description: null,
        entryType: null
      },
      messages: {
        title: {
          required: 'Введите название клуба',
          isNotExist: 'Клуб с&nbsp;таким названием уже существует',
          maxLength: 'Название клуба должно быть не&nbsp;более {0}&nbsp;символов',
          allowedChars: 'Название содержит запрещенные символы'
        },
        logo: {
          required: 'Загрузите логотип клуба'
        },
        location: {
          required: 'Укажите страну, город или&nbsp;полный адрес клуба',
          isFilled: 'Выберите адрес из выпадающего списка'
        },
        disciplines: {
          required: 'Укажите спортивную специализацию'
        },
        description: {
          required: 'Опишите ваш клуб в&nbsp;подробностях'
        }
      },
      showErrors: false,
      isSending: false,
      isFilled: false,
      isSent: false,
      addresses: [],
      address: {},
      nameIsChecking: false,
      nameIsChecked: false,
      nameIsExist: false,
      locationIsLoading: false,
      locationNotFound: false,
      savedData: null,
      logoFormatError: false,
      logoSizeError: false
    }
  },
  validations: {
    fields: {
      title: {
        required,
        maxLength: maxLength(80),
        allowedChars (value) {
          // Example: Тест Test &!?"-:,._ 0123456789
          return /^[\p{L}\p{N}\p{M}\s&!?"\-:,._]+$/u.test(value)
        },
        isNotExist (val) {
          return !this.nameIsExist || this.ownName === val
        }
      },
      logo: {
        required
      },
      location: {
        required: requiredIf(model => !model.isOnline),
        isFilled (val) {
          if (this.fields.isOnline && !val) {
            return true
          }
          return val === this.address.value
        }
      },
      disciplines: {
        required
      },
      description: {
        required,
        isFilled (val) { return val !== '<p></p>' }
      }
    }
  },
  computed: {
    ...mapState('club', ['clubCode', 'clubInfo']),
    ...mapGetters('clubs', ['sportTypesFilterValues']),
    disciplinesColumns () {
      const disciplines = this.sportTypesFilterValues
      const index = Math.round(disciplines.length / 2)
      return [disciplines.slice(0, index), disciplines.slice(index)]
    },
    locationDropdownIsOpened () {
      return this.$refs.locationDropdown && this.$refs.locationDropdown.isShown
    },
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    },
    isLoaded () {
      return this.clubInfo && this.clubCode === this.idClub
    },
    hasChanges () {
      if (!this.savedData) {
        return false
      }
      return !isEqual(this.savedData.fields, this.fields) ||
        !isEqual(this.savedData.address, this.address)
    }
  },
  methods: {
    ...mapActions('club', ['editClub', 'checkNameIsExist', 'getClubInfo']),
    ...mapActions('clubs', ['getClubsFilters']),
    ...mapActions('alerts', ['addSuccessAlert', 'addSomethingWrongAlert']),
    ...mapMutations('club', ['triggerInfoUpdate']),
    onLogoChange ($event) {
      const file = this.$refs.file
      this.logoFormatError = file.formatError
      this.logoSizeError = file.sizeError
      this.$refs.cropper.setupCropper($event)
      this.hideCropper = false
    },
    onCropperChange (val) {
      this.fields.logo = val
      if (!this.hideCropper) {
        this.$v.fields.logo.$touch()
      }
    },
    scrollToError () {
      setTimeout(() => {
        const firstErrorEl = document.querySelector('.has-error')
        const offset = firstErrorEl.getBoundingClientRect().top + document.documentElement.scrollTop - 112
        window.scrollTo(0, offset)
      }, 10)
    },
    prepareData () {
      return {
        clubId: this.clubInfo.id,
        name: this.fields.title,
        imageLogo: this.fields.logo,
        imageLogoName: this.getLogoName(this.clubInfo.logoUrl),
        address: this.fields.location,
        sportTypeIds: this.fields.disciplines,
        description: this.fields.description,
        isOnline: this.fields.isOnline,
        clubPrivacy: this.fields.entryType ? 2 : 1,
        country: this.address.country,
        city: this.address.city,
        latitude: this.address.latitude,
        longitude: this.address.longitude,
        hasAgreement: this.clubInfo.hasAgreement
      }
    },
    submit () {
      this.showErrors = true
      this.$v.$touch()

      if (this.$v.$anyError || this.nameIsChecking) {
        this.scrollToError()
        return
      }

      this.isSending = true

      const logoIsBase64 = this.fields.logo.indexOf('data:image/') !== -1

      if (!logoIsBase64) {
        this.$refs.cropper.setupCropper(null, this.fields.logo)
        this.$refs.logoPreview.addEventListener('load', this.saveClub, { once: true })
        return
      }

      this.saveClub()
    },
    saveClub () {
      const clubData = this.prepareData()

      this.editClub(clubData)
        .then((response) => {
          this.isSending = false
          if (response.data.isSuccess) {
            this.triggerInfoUpdate()
            this.getClubInfo(this.idClub)
            this.addSuccessAlert('Информация обновлена')
            this.isSending = false
            this.isSent = true
            setTimeout(() => {
              this.savedData = {
                fields: clone(this.fields),
                address: clone(this.address)
              }
              this.isSent = false
            }, 1500)
            return
          }
          this.addSomethingWrongAlert(response.data.errorMessage)
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.isSending = false
        })
    },
    loadAddressesList () {
      if (!this.fields.location) {
        this.addresses = []
        this.address = {}
        return
      }
      this.locationNotFound = false
      getAddresses({ searchQuery: this.fields.location })
        .then(response => {
          const options = response.data.suggestions.map((suggest) => {
            const data = suggest.data
            return {
              value: suggest.value,
              valueMarked: markQueryInStr(suggest.value, this.fields.location),
              country: data.country,
              region: data.region_with_type,
              area: data.area_with_type,
              city: data.city || data.settlement,
              countryCode: data.country_iso_code,
              cityFiasId: data.city_fias_id || null,
              house: data.house,
              latitude: data.geo_lat,
              longitude: data.geo_lon
            }
          })
          this.addresses = options
          this.locationIsLoading = false
          this.locationNotFound = options.length === 0
        })
    },
    loadAddresses () {
      this.locationIsLoading = true
      if (this.debouncedLocation) {
        clearTimeout(this.debouncedLocation)
      }
      this.debouncedLocation = setTimeout(this.loadAddressesList, 400)
    },
    saveLocation (address) {
      this.fields.location = address.value
      this.address = address
    },
    checkName () {
      if (!this.fields.title || this.$v.fields.title.$error || this.fields.title === this.ownName) {
        this.nameIsExist = false
        return
      }
      this.nameIsChecking = true
      this.nameIsExist = false
      this.checkNameIsExist({ name: this.fields.title })
        .then(response => {
          this.nameIsExist = response.data.isExist
          this.nameIsChecking = false
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.fields.title = ''
          this.nameIsExist = false
          this.nameIsChecking = false
        })
    },
    getLogoName (url) {
      if (!url) {
        return null
      }
      const name = url.split('/')
      return name[name.length - 1]
    },
    setData () {
      this.isFilled = false

      const data = this.clubInfo

      this.address = {
        value: data.address,
        country: data.country,
        city: data.city,
        latitude: data.latitude,
        longitude: data.longitude
      }

      this.fields = {
        title: data.name,
        logo: data.logoUrl,
        logoName: this.getLogoName(data.logoUrl),
        location: data.address,
        isOnline: data.isOnline,
        disciplines: data.sportTypeIds,
        description: data.description,
        entryType: !!(data.clubPrivacy === 'private' || data.clubPrivacy === 2)
      }

      this.savedData = {
        fields: clone(this.fields),
        address: clone(this.address)
      }

      this.ownName = data.name
      this.nameIsChecked = true
      this.isFilled = true
    }
  },
  watch: {
    isLoaded (val) {
      val && this.setData()
    }
  },
  mounted () {
    this.getClubsFilters()
    this.getClubInfo(this.idClub)
    if (this.isLoaded) {
      this.setData()
    }
  }
}
</script>

<style lang="scss">
  .location-dropdown {
    width: 100%;

    .dropdown__block {
      padding: 2px 0;
    }

    .dropdown__link {
      white-space: normal;
      font-weight: normal;
    }
  }
</style>
